import { render, staticRenderFns } from "./counsels-report-card.vue?vue&type=template&id=57a93755&scoped=true&"
import script from "./counsels-report-card.vue?vue&type=script&lang=js&"
export * from "./counsels-report-card.vue?vue&type=script&lang=js&"
import style0 from "./counsels-report-card.vue?vue&type=style&index=0&id=57a93755&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57a93755",
  null
  
)

export default component.exports